import { createApp } from "vue";
import DOMUtils from "@utils/dom.utils";
import ContentModal from "./components/ContentModal";
import MessageModal from "./components/MessageModal";
import ModalContainer from "./components/ModalContainer";
import ModalContent from "./components/ModalContent";
import { isDefined } from "@utils/var.check";
import AppInstanceUtils from "@plugins/common/service/app.instance.utils";

const getModalContainer = (plugin) => {
  const modalContainer = document.getElementById("modal-container");
  if (modalContainer) {
    plugin.containerComponent = ModalContainerComponent; //modalContainer.__vueParentComponent.ctx;
  } else {
    const container = DOMUtils.createDivInBody({});
    const app = createApp(ModalContainer, {
      //parent: plugin
    });
    AppInstanceUtils.installCommonPlugin(app);
    plugin.containerComponent = app.mount(container);
    DOMUtils.replaceComponentWrapperWithComponentElement(plugin.containerComponent);
    ModalContainerComponent = plugin.containerComponent;
  }
  return plugin.containerComponent;
};

let ModalContainerComponent;

const Plugin = {
  install(app, options) {
    /**
     * Register Component
     */
    app.component("modal-container", ModalContainer);
    app.component("modal-content", ModalContent);
    app.component("content-modal", ContentModal);

    this.containerComponent = null;
    this.params = options;

    const showModal = (modal, params, listeners, allowMultipleModals) => {
      const root = params && params.root ? params.root : Plugin;
      const container = getModalContainer(root);

      return container.add(modal, params, listeners, allowMultipleModals);
    };

    const removeModal = (params) => {
      const root = params && params.root ? params.root : Plugin;
      const container = getModalContainer(root);

      container.remove(params);
    };

    const removeAllModals = (params) => {
      const root = params && params.root ? params.root : Plugin;
      const container = getModalContainer(root);
      container.removeAll();
    };

    const setDefaultParams = (type, params) => {
      //set default params
      if (isDefined(params)) {
        params.type = type;
        params.size = isDefined(params.size)
          ? params.size === "minimised"
            ? "minimised"
            : ""
          : "";
        params.useStateButton = isDefined(params.useStateButton) ? params.useStateButton : false;
        params.use_primaryButton = isDefined(params.use_primaryButton)
          ? params.use_primaryButton
          : true;
        params.use_secondaryButton = isDefined(params.use_secondaryButton)
          ? params.use_secondaryButton
          : true;
        params.use_label = isDefined(params.use_label) ? params.use_label : true;
        params.use_title = isDefined(params.use_title) ? params.use_title : true;
        params.use_content = isDefined(params.use_content) ? params.use_content : true;
        params.primaryBtnKind = isDefined(params.primaryBtnKind)
          ? params.primaryBtnKind
          : "primary";
        params.primaryBtnLabel = isDefined(params.primaryBtnLabel) ? params.primaryBtnLabel : "OK";
        params.primaryBtnCompletedLabel = isDefined(params.primaryBtnCompletedLabel)
          ? params.primaryBtnCompletedLabel
          : "COMPLETED";
        params.primaryBtnErrorLabel = isDefined(params.primaryBtnErrorLabel)
          ? params.primaryBtnErrorLabel
          : "ERROR";
        params.secondaryBtnLabel = isDefined(params.secondaryBtnLabel)
          ? params.secondaryBtnLabel
          : "CANCEL";
        params.primaryButtonDisabled = isDefined(params.primaryButtonDisabled)
          ? params.primaryButtonDisabled
          : false;
      }
    };

    /**
     * Plugin API
     */
    app.config.globalProperties.$modal = {
      show(modal, params = {}, listeners = {}, allowMultipleModals) {
        if (typeof modal === "object" || typeof modal === "function") {
          return showModal(modal, params, listeners, allowMultipleModals);
        }
      },

      showMessage(type, params, allowMultipleModals) {
        if (typeof type === "string") {
          switch (type) {
            case "success":
            case "warning":
            case "info":
            case "error":
              setDefaultParams(type, params);
              return showModal(MessageModal, params, {}, allowMultipleModals);
            default:
              break;
          }
        }
      },

      remove(params = {}) {
        removeModal(params);
      },

      removeAll(params = {}) {
        removeAllModals(params);
      },
    };
    this.$modal = app.config.globalProperties.$modal;
  },
};

export default Plugin;
